// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".country-flag[data-v-edfce134]{border-radius:2px;height:20px;margin-right:10px;width:30px}.prefix[data-v-edfce134]{color:#676767;margin-left:10px}[data-v-edfce134] .v-autocomplete.v-select.v-input--is-focused input{min-width:0!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
